function initRouter (VueRouter, components) {
  
  /* HOWITWORKS

    Each route is defined with a path, name, component, and props. We use PageTemplate for most pages, which accepts different components to populate itself. PageTemplate is the parent for the Filter, List, and Details pages. 
    
    There are 2 router-views in the application, one for the main App vue and one for the external pages. The key inside "components" will define which router-view will receive which component, so you can handle the same route 2 different ways depending on which router-view is being used at the time.

    props: {
      listComponent: Template for 1 list item, which accepts the data for an individual item. The List.vue component will make a list using this as the template
      pageComponent: The main content being displayed (usually the details of a selected list item)
      drawerComponent: If the page has a closeable drawer (ie: Ticket Chat) what template to populate it with
      drawerQuery: query string to toggle a closeable drawer
      pageKey: All these tabs require a reference to one of the main AppData instance "pages" props. This specifies which page object to use.

    }
  
  */

  return new VueRouter({
    mode: 'history',
    routes: [
      // INAPP ROUTES
      {
        path: '/tickets',
        name: 'tickets',
        components: {
          app: components.PageTemplate
        },
        props: {
          app: {
            listComponent: components.TicketList,
            pageComponent: components.TicketDetails,
            drawerComponent: components.TicketChat,
            drawerQuery: 'chat',
            pageKey: 'tickets'
          }
        }
      },
      {
        path: '/people/joined',
        components: {
          app: components.PageTemplate
        },
        name: 'joined',
        props: {
          app: {            
            listComponent: components.PeopleList,
            pageComponent: components.PeopleDetails,
            pageKey: 'joined'
          }
        }
      },
      {
        path: '/people/invited',
        name: 'invited',      
        components: {
          app: components.PageTemplate,
        },
        props: {
          app: {                      
            listComponent: components.InviteList,
            pageComponent: components.InviteDetails,
            pageKey: 'invited'
          }
        }   
      },
      {
        path: '/units',
        name: 'units',      
        components: {
          app: components.PageTemplate
        },
        props: {
          app: {                      
            listComponent: components.UnitList,
            pageComponent: components.UnitDetails,
            pageKey: 'units'
          }
        }    
      },
      {
        path: '/settings',
        name: 'settings',      
        components: {
          app: components.Page
        },
        props: {
          app: {            
            pageComponent: components.Settings,
            pageKey: 'settings'
          }
        }    
      },
      {
        path: '/company/properties',
        name: 'properties',
        components: {
          app: components.PageTemplate,
        },
        props: {
          app: {
            listComponent: components.PropertyList,
            pageComponent: components.PropertyDetails,
            pageKey: 'properties'
          }
        }
      },
      {
        path: '/company/roleTemplates',
        name: 'roleTemplates',
        components: {
          app: components.PageTemplate,
        },
        props: {
          app: {
            listComponent: components.RoleTemplateList,
            pageComponent: components.RoleTemplateDetails,
            pageKey: 'roleTemplates'
          }
        }
      },
      {
        path: '/company/ticketTags',
        name: 'ticketTags',
        components: {
          app: components.PageTemplate,
        },
        props: {
          app: {
            listComponent: components.TicketTagList,
            pageComponent: components.TicketTagDetails,
            pageKey: 'ticketTags'
          }
        }
      },
      {
        path: '/signout',
        name: 'signout',
        components: {
          app: components.Signout,
        } // HOWITWORKS: This component has a created() hook that runs the signout functionality, and causes the App.vue if-else template condition to meet the vo-login condition.
      },

      // EXTERNAL ROUTES
      {
        path: '/changelog',
        name: 'changelog',
        components: {
          app: components.ExternalRedirect,
          external: components.ExternalChangelog
        }
      },
      {
        path: '/emailChanged',
        name: 'emailChanged',
        components: {
          app: components.ExternalRedirect,
          external: components.ExternalChangeEmail
        }
      },
      {
        path: '/knowledgeBase',
        name: 'knowledgeBase',
        components: {
          app: components.ExternalRedirect,
          external: components.ExternalKnowledgeBase
        }
      },
      {
        path: '/policy',
        name: 'policy',
        components: {
          app: components.ExternalRedirect,
          external: components.ExternalPolicy
        }
      },
      {
        path: '/setupAccount',
        name: 'setupAccount',
        components: {
          app: components.ExternalRedirect,
          external: components.ExternalAccountSetup
        }
      },
      {
        path: '/resetPassword',
        name: 'resetPassword',
        components: {
          app: components.ExternalRedirect,
          external: components.ExternalPasswordReset
        }
      },
      {
        path: '/support',
        name: 'support',
        components: {
          app: components.ExternalRedirect,
          external: components.ExternalSupport
        }
      },
      {
        path: '/',
        name: 'login',
        components: {
          app: components.InAppRedirect, // User shouldn't access this route when they're in the app, kick them to whatever they have access to
          external: components.Login
        }
      },
      {
        path: '/*',
        components: {
          app: components.InAppRedirect, // User shouldn't access this route when they're in the app, kick them to whatever they have access to
          external: components.Login
        }
      },
    
    ]
  });
}

export default { initRouter }


// WEBPACK FOOTER //
// ./src/router.js